import { Outlet, createBrowserRouter } from "react-router-dom";

import { RouteErrorElement } from "@components/Error/RouteErrorElement.tsx";
import { PublicNavBar } from "@components/PublicNavBar/PublicNavBar";
import { ClaimClinic } from "@pages/Clinic/ClaimClinic";
import { Support } from "@pages/Support/Support";

import "./index.css";

export const PUBLIC_PATHS: string[] = ["/claim", "/support"];
export const isPublicPath = (pathname: string) =>
  PUBLIC_PATHS.some((p) => pathname === p || pathname.startsWith(p + "/"));

/**
 * All paths below are publicly accessible and should not use any internal APIs that show sensitive data
 */
export const publicRouter = createBrowserRouter([
  {
    element: <PublicNavBar />,
    errorElement: <RouteErrorElement />,
    children: [
      {
        path: "/claim",
        element: <Outlet />,
        children: [
          { index: true, element: <RouteErrorElement /> },
          { path: ":leadId", element: <ClaimClinic /> },
        ],
      },
      {
        path: "/support",
        element: <Support />,
      },
    ],
  },
]);
